// extracted by mini-css-extract-plugin
export default {"cardsWrapper":"Gallery_cardsWrapper__G9vYj","galleryWrapper":"Gallery_galleryWrapper__Ftd53","galleryWrapperBottom":"Gallery_galleryWrapperBottom__LENUC"};